import { Link, LinkProps } from '@awazevr/design-system.components.link'
import { convertLinkToAbsoluteUrl } from '../../utils/helpers/helpers'
import { useContext } from 'react'
import { GlobalProps } from '../../utils/globalProps'

export const LinkModule: React.FC<LinkProps> = ({
  href,
  children,
  ...rest
}) => {
  const { host } = useContext(GlobalProps)
  const urlHref = convertLinkToAbsoluteUrl(href, host)

  return (
    <Link href={urlHref} {...rest}>
      {children}
    </Link>
  )
}
